import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPhoneConfirmationState } from '../../types/phoneConfirmation/phoneConfirmation';

const initialState: IPhoneConfirmationState = {
  status: 'initial',
  secondsToRetry: 0,
};

export const phoneConfirmationSlice = createSlice({
  name: 'phoneConfirmation',
  initialState,
  reducers: {
    setPhoneConfirmationRequestSubmitting: state => {
      return {
        ...state,
        status: 'pending',
        error: undefined,
        secondsToRetry: 0,
      };
    },
    setPhoneConfirmationRequestSuccess: (state, action: PayloadAction<{ error?: string; secondsToRetry?: number }>) => {
      return {
        ...state,
        status: 'fulfilled',
        secondsToRetry: action.payload?.secondsToRetry || 0,
      };
    },
    setPhoneConfirmationRequestFailure: (state, action: PayloadAction<{ error?: string; secondsToRetry?: number }>) => {
      return {
        ...state,
        status: 'rejected',
        error: action.payload?.error,
        secondsToRetry: action.payload?.secondsToRetry || 0,
      };
    },
    setPhoneConfirmationError: (
      state,
      action: PayloadAction<{
        error?: string;
        secondsToRetry?: number;
      }>,
    ) => {
      return {
        ...state,
        error: action.payload?.error,
        secondsToRetry: action.payload?.secondsToRetry || state.secondsToRetry,
      };
    },
  },
});

export const {
  reducer: phoneConfirmationReducer,
  actions: {
    setPhoneConfirmationRequestSubmitting,
    setPhoneConfirmationRequestSuccess,
    setPhoneConfirmationRequestFailure,
    setPhoneConfirmationError,
  },
} = phoneConfirmationSlice;
